<template>
  <b-modal id="delete-access-rule" ref="delete-access-rule" ok-title="Delete" ok-variant="danger" @ok="deleteAccessRule($event)">
    <template #modal-title>
      <div>
        <h5 class="mb-0">Deleting Access Rules</h5>
        <small class="text-muted">Email: {{ email }} / Rule Type: {{ ruleType }}</small>
      </div>
    </template>
    <b-alert v-if="accessRuleError" show variant="danger">
      {{ accessRuleError }}
    </b-alert>
    <p class="mb-0">You're deleting the following access rules:</p>
    <ul class="mb-0">
      <li v-for="(item,index) in accessRules" :key="index">
        Access via: {{ item.accessVia }} (affects {{ item.affected_machines_count }} {{ item.affected_machines_count !== 1 ? 'machines' : 'machine' }})
      </li>
    </ul>
  </b-modal>
</template>

<script>

export default {
  name: 'AccessRulesModalDelete',
  data () {
    return {
      accessRulesGroup: null,
      accessRuleError: null,
      email: null,
      ruleType: null,
    }
  },
  computed: {
    accessRules: function () {
      const rows = []
      this.accessRulesGroup?.access_rules.forEach(rule => {
        const dealer = rule.access_machine_dealer
        const accessViaDealer = dealer !== null
        const accessVia = accessViaDealer ? `Dealer "${dealer}"` : `Machine Serial "${rule.access_machine_serial}"`

        // If access is granted via a dealer, count how often this dealer appears in affected_machines
        // If access is granted via a serial, return 1 as a machine serial can only grant access to 1 machine
        let counts = accessViaDealer
            ? this.accessRulesGroup.affected_machines.filter(
                machine => machine.access_rules[0].access_machine_dealer === dealer
            ).length
            : 1

        rows.push({ accessVia, 'affected_machines_count': counts })
      })

      return rows
    }
  },
  methods: {
    show (data, email, ruleType) {
      this.accessRulesGroup = data
      this.email = email
      this.ruleType = ruleType
      this.$refs['delete-access-rule'].show()
    },
    async deleteAccessRule (event) {
      event.preventDefault()
      try {
        await this.$store.dispatch('deleteAccessRule', this.accessRulesGroup)
        this.$refs['delete-access-rule'].hide()
        this.accessRuleError = null
      } catch (error) {
        this.accessRuleError = 'Failed deleting access rule. ' + error
      }
    },
  }
}
</script>

<style lang="scss">
</style>
